import React, {useEffect} from 'react';

import {recordRumAction} from '../../util/datadog/datadogRum';
import {useStablePanelId} from '../Panel/PanelIDContext';
import {DelayRender} from './DelayRender';
import {usePanelSystemMetricsContext} from './SystemMetrics/PanelSystemMetricsContext';

export const DelayRenderWrapper = ({title}: {title: string}) => {
  const panelId = useStablePanelId();
  const {setAllowUncappedMetrics} = usePanelSystemMetricsContext();
  useEffect(
    function reportCappedPanelMounted() {
      recordRumAction('system_metrics_capped_panel_mounted', {title, panelId});
    },
    [title, panelId]
  );
  function onLoadAnyway() {
    recordRumAction('system_metrics_capped_panel_displayed', {title, panelId});
    setAllowUncappedMetrics(true);
  }
  return <DelayRender onLoadAnyway={onLoadAnyway} />;
};
